import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d835747c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.fullPath
        }))
      ]),
      _: 1
    })
  ]))
}